'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import http from 'hub-http/clients/apiClient';
import * as byModuleId from 'DesignData/api/CustomWidgetsByModuleId';
import { STAGED } from 'DesignData/enums/StagingEnvironments';
import { formatPathSlug } from '../lib/path';
export { byModuleId };
const BASE_API_PATH = 'designmanager/v1/modules';
/**
 * POST designmanager/v1/modules
 * @deprecated Use /by-module-id
 */

export function create(customWidget) {
  return http.post(BASE_API_PATH, {
    data: customWidget
  });
}
/**
 * GET designmanager/v1/modules/:customWidgetId
 * @deprecated Use /by-module-id
 */

export function fetch(customWidgetId) {
  return http.get(`${BASE_API_PATH}/${customWidgetId}`);
}
/**
 * GET designmanager/v1/modules?:query
 */

export function fetchQuery(query = {}) {
  return http.get(`${BASE_API_PATH}/combined`, {
    query
  });
}
/**
 * GET designmanager/v1/modules/by-path/:path
 */

export function fetchByPath(path) {
  return http.get(`${BASE_API_PATH}/by-path/${encodeURIComponent(path)}`);
}
/**
 * PUT designmanager/v1/modules/:customWidgetId
 * @deprecated Use /by-module-id
 */

export function save(customWidgetId, data) {
  return http.put(`${BASE_API_PATH}/${customWidgetId}`, {
    data
  });
}
/**
 * DELETE designmanager/v1/modules/:customWidgetId
 * @deprecated Use /by-module-id
 */

export function del(customWidgetId) {
  return http.delete(`${BASE_API_PATH}/${customWidgetId}`);
}
/**
 * DELETE designmanager/v1/modules/bulk?id=1&id=2
 * @deprecated Use /by-module-id
 */

export function bulkDelete(customWidgetIds) {
  return http.delete(`${BASE_API_PATH}/bulk`, {
    query: {
      id: customWidgetIds
    }
  });
}
/**
 * POST designmanager/v1/modules/:customWidgetId/clone
 * @deprecated Use /by-module-id
 */

export function clone(customWidgetId, data = {}) {
  const {
    name: newName,
    schemaVersion,
    isAvailableForNewContent,
    isEnabledForEmailV3Rendering,
    shouldReplaceNestedModules,
    displayName
  } = data;
  return http.post(`${BASE_API_PATH}/${customWidgetId}/clone`, {
    query: {
      newName
    },
    data: {
      schemaVersion,
      isAvailableForNewContent,
      isEnabledForEmailV3Rendering,
      shouldReplaceNestedModules,
      displayName
    }
  });
}
/**
 * POST designmanager/v1/modules/clone/by-path/:path
 */

export function cloneByPath(path, cloneData = {}) {
  const {
    name: newName
  } = cloneData,
        data = _objectWithoutPropertiesLoose(cloneData, ["name"]);

  return http.post(`${BASE_API_PATH}/clone/by-path/${encodeURIComponent(path)}`, {
    query: {
      newName,
      environmentId: STAGED
    },
    data
  });
}
/**
 * PUT designmanager/v1/modules/:customWidgetId/restore-deleted
 * @deprecated Use /by-module-id
 */

export function restoreDeleted(customWidgetId) {
  return http.put(`${BASE_API_PATH}/${customWidgetId}/restore-deleted`);
}

function fetchUntilDone(result) {
  const {
    total,
    offset,
    limit,
    objects = []
  } = result;
  const nextOffset = offset + limit;

  if (objects.length && total > nextOffset) {
    return http.get(`${BASE_API_PATH}/combined`, {
      query: {
        order: 'name',
        property: ['!source', '!js', '!css'],
        offset: nextOffset,
        limit
      },
      timeout: 60000
    }).then(next => {
      return fetchUntilDone(next).then(end => [...objects, ...end]);
    });
  }

  return Promise.resolve(objects);
}
/**
 * GET  designmanager/v1/modules
 */


export function fetchCustomWidgets(query) {
  return http.get(`${BASE_API_PATH}/combined`, {
    query: Object.assign({
      order: 'name',
      property: ['!source', '!js', '!css']
    }, query),
    timeout: 60000
  }).then(result => fetchUntilDone(result));
}
/**
 * GET  designmanager/v1/modules/builtin-mapping
 */

export function fetchMapping() {
  return http.get(`${BASE_API_PATH}/builtin-mapping`);
}
/*
 * POST /designmanager/v1/modules/by-path/p:path
 */

export function createByPath(path, moduleData) {
  return http.post(`${BASE_API_PATH}/by-path/${formatPathSlug(path)}`, {
    data: moduleData,
    query: {
      environmentId: STAGED
    }
  });
}
/**
 * PUT /designmanager/v1/modules/by-path/p:path
 */

export function saveByPath(modulePath, moduleData) {
  return http.put(`${BASE_API_PATH}/by-path/${formatPathSlug(modulePath)}`, {
    data: moduleData,
    query: {
      environmentId: STAGED
    }
  });
}